import type { TranslationKey } from './en';

// Finnish strings; must define every key of en.ts.
export const fi: Record<TranslationKey, string> = {
    app_name: "NHLCountries",

    // Header, menu, tabs
    tab_today: "Tänään",
    tab_upcoming: "Tulevat",
    tab_season: "Kausi",
    tab_league: "Liiga",
    nav_label: "Osiot",
    header_country: "Maa",
    header_language: "Kieli",
    menu_open: "Valikko",
    menu_updated: "Päivitetty",
    menu_refreshFailing: "Päivitys ei onnistunut, yritetään uudelleen",
    menu_theme: "Teema",
    theme_auto: "Auto",
    theme_light: "Vaalea",
    theme_dark: "Tumma",
    theme_teletext: "Teksti-TV",
    menu_feedback: "Palaute",
    menu_showAddress: "näytä osoite",
    menu_hideAddress: "piilota osoite",
    menu_version: "Versio",
    menu_league: "Sarja",
    menu_whatsNew: "Mitä uutta",
    whatsNew_title: "Mitä uutta",
    whatsNew_error: "Uutisia ei saatu haettua.",
    whatsNew_empty: "Ei vielä uutisia.",

    // Data states
    state_loading: "Haetaan tietoja…",
    state_noData: "Tietojen haku epäonnistui.",
    state_retry: "Yritä uudelleen",
    state_noPlayers: "Ei pelaajia",
    state_noGames: "Ei pelejä",
    state_leagueUnavailable: "{{league}}-tietoja ei ole juuri nyt saatavilla.",
    state_toNhl: "Siirry NHL:ään",
    error_view: "Näkymän lataus epäonnistui.",

    // Countries
    country_canada: "Kanada",
    country_czechia: "Tšekki",
    country_denmark: "Tanska",
    country_finland: "Suomi",
    country_france: "Ranska",
    country_germany: "Saksa",
    country_latvia: "Latvia",
    country_norway: "Norja",
    country_russia: "Roistovaltio",
    country_slovakia: "Slovakia",
    country_sweden: "Ruotsi",
    country_switzerland: "Sveitsi",
    country_usa: "Yhdysvallat",

    // Weekdays
    day_monday: "Ma",
    day_tuesday: "Ti",
    day_wednesday: "Ke",
    day_thursday: "To",
    day_friday: "Pe",
    day_saturday: "La",
    day_sunday: "Su",

    // Tänään
    today_games: "Pelit",
    today_players: "Pelaajat",
    today_view: "Näkymä",
    filter_label: "Tulosten näyttö",
    filter_all: "Kaikki",
    filter_none: "Ei",
    hide_button: "Piilotetut joukkueet",
    hide_enabled: "Piilotus käytössä",
    common_done: "Valmis",
    game_show: "näytä",
    game_showFor: "Näytä peli {{teams}}",
    play_open: "Videot",
    play_recap: "Lyhyt kooste",
    play_condensed: "Pitkä kooste",
    goal_video: "Maalin video",
    points_short: "{{n}}p",
    chart_perDay: "Pisteet per päivä",
    chart_distribution: "Pistejakauma",
    chart_distributionHint: "Päiviä, joina saatiin n pistettä",
    col_player: "Pelaaja",
    col_game: "Peli",
    col_points: "P",
    col_shots: "L",
    col_plusMinus: "+/-",
    col_toi: "A",
    col_savePct: "T%",
    col_saves: "T/L",
    today_goalies: "Maalivahdit",
    today_noPlayersYet: "Ei vielä pelanneita pelaajia",
    today_locked: "Pelaajien tilastot piilotettu, koska tulokset on kytketty pois.",
    today_showAnyway: "Näytä silti",
    today_hiddenTeamsPlayers: "Piilotettujen joukkueiden pelaajia ei näytetä.",
    tracker_title: "Pisteseuranta",
    tracker_notPlaying: "Ei kokoonpanossa",
    tracker_upcoming: "Tulossa",
    tracker_start: "Alkaa",
    tracker_clock: "Peliaika",
    tracker_noPlayers: "Ei pelaajia tänä pelipäivänä",
    injury_dtd: "Poissa päivä kerrallaan",
    injury_out: "Poissa tuntemattoman ajan",
    injury_ir: "Sairaslistalla",
    shotType_tipIn: "Ohjaus",
    shotType_wristShot: "Ranneveto",
    shotType_slapShot: "Lämäri",
    shotType_deflected: "Kimmoke",
    shotType_snapShot: "Nopea veto",
    shotType_backhand: "Rystykuti",
    shotType_wrapAround: "Vanhanaikainen",
    shotType_poke: "Tökkäys",
    shotType_bat: "Huitaisu",
    shotType_betweenLegs: "Jalkojen välistä",
    goalType_pp: "YV",
    goalType_sh: "AV",
    goalType_en: "TM",
    gameEndingType_so: "VL",
    gameEndingType_ot: "JA",
    gameStatus_ppd: "Siirretty",
    gameStatus_tbd: "Ei tietoa",
    scores_game: "Ottelu",
    scores_tied: "sarja tasan",
    scores_lead: "johtaa sarjaa",
    scores_win: "voitti sarjan",
    scores_notStarted: "sarja tasan 0-0",
    scores_startsSoon: "pian",
    scores_preSeasonGame: "Harjoituspeli",

    // Column names in full (tooltips and screen readers)
    today_totalLabel: "Kierroksen pisteet",
    today_yesterday: "Eilen",
    scFull_name: "Nimi",
    scFull_team: "Joukkue",
    scFull_games: "Ottelut",
    scFull_goals: "Maalit",
    scFull_assists: "Syötöt",
    scFull_points: "Pisteet",
    scFull_pointsPerGame: "Pisteet per peli",
    scFull_toi: "Peliaika per peli",
    scFull_plusMinus: "Plus/minus",
    scFull_shotPct: "Laukaisuprosentti",
    scFull_faceoffPct: "Aloitusprosentti",
    scFull_primaryPosition: "Pelipaikka",
    scFull_age: "Ikä",
    scFull_pim: "Jäähyminuutit",
    scFull_hits: "Taklaukset",
    scFull_shots: "Laukaukset",
    scFull_blocked: "Blokit",
    scFull_saves: "Torjunnat",
    scFull_shotsAgainst: "Laukaukset maalia kohti",
    scFull_savePct: "Torjuntaprosentti",
    scFull_gaa: "Päästetyt maalit per peli",
    scFull_wins: "Voitot",
    scFull_losses: "Tappiot",
    scFull_ot: "Jatkoaikatappiot",
    scFull_sweaterNumber: "Pelinumero",
    scFull_contract: "Sopimus päättyy",
    scFull_capHit: "Palkkakattovaikutus",

    // Tulevat
    upcoming_teams: "Joukkueet",
    upcoming_showPlayers: "Näytä pelaajat",
    upcoming_teamsTitle: "Näytettävät joukkueet",
    upcoming_allTeams: "Kaikki joukkueet",
    upcoming_none: "Ei tulevia pelejä",

    // Kausi
    season_stats: "Tilastot",
    season_countryPoints: "Maapisteet",
    season_news: "Uutiset",
    season_nationalTeam: "Maajoukkue",
    season_view: "Kausi-näkymä",
    stats_skaters: "Kenttäpelaajat",
    stats_goalies: "Maalivahdit",
    stats_playerType: "Pelaajatyyppi",
    stats_scope: "Pelaajat",
    stats_all: "Kaikki",
    stats_average: "Keskiarvo",
    stats_total: "Yhteensä",
    stats_noPlayers: "Ei pelaajia, joilla on otteluita",
    stats_loadingAll: "Haetaan kaikkien maiden pelaajia…",
    statColumn_name: "Nimi",
    statColumn_team: "J",
    statColumn_games: "O",
    statColumn_goals: "M",
    statColumn_assists: "S",
    statColumn_points: "P",
    statColumn_pointsPerGame: "P/P",
    statColumn_toi: "A",
    statColumn_plusMinus: "+/-",
    statColumn_shotPct: "L%",
    statColumn_faceoffPct: "A%",
    statColumn_primaryPosition: "Pp",
    statColumn_age: "Ikä",
    statColumn_penaltyMinutes: "RM",
    statColumn_sweaterNumber: "PN",
    statColumn_contract: "Sop",
    statColumn_capHit: "$",
    statColumn_saves: "T",
    statColumn_shotsAgainst: "L",
    statColumn_savePct: "T%",
    statColumn_gaa: "PMK",
    statColumn_wins: "V",
    statColumn_losses: "H",
    statColumn_ot: "JAH",
    news_none: "Ei poissaolouutisia",
    news_loading: "Haetaan uutisia…",
    age_minutes: "{{n}} min",
    age_hours: "{{n}} t",
    age_days: "{{n}} pv",
    nt_forwards: "Hyökkääjät",
    nt_defence: "Puolustajat",
    nt_reserve: "Varalla",
    nt_notEnoughGames: "Lisää otteluita tarvitaan",
    nt_filter: "Joukkuevalinta",
    nt_belowLine: "Pudotuspeliviivan alla",
    nt_capHit: "Joukkueen palkkakattovaikutus",
    nt_contractEnds: "Sop. {{year}}",
    nt_empty: "Ei pelaajia valittavaksi",

    // Liiga
    league_standings: "Taulukko",
    league_playoffs: "Pudotuspelit",
    league_tank: "Tankkaus",
    league_playoffsAndTank: "Pudotuspelit ja tankkaus",
    league_view: "Liiga-näkymä",
    league_conference: "Konferenssi",
    league_east: "Itä",
    league_west: "Länsi",
    league_wc: "VK",
    league_pairsTitle: "1. kierroksen parit",
    league_pairsNote: "nykyisen sarjataulukon mukaan",
    league_belowLine: "Viivan alla",
    league_vsWc: "ero VK2:een",
    league_noTeams: "Sarjataulukkoa ei ole vielä",
    league_conferenceTank: "Tankkaus",
    standings_games: "O",
    standings_points: "P",
    standings_wins: "V",
    standings_losses: "H",
    standings_ot: "JA",
    standings_rw: "VV",
    standings_row: "VVJ",
    standings_gr: "OJ",
    standings_pointsPct: "P%",
    league_notePointsPct: "pisteprosentti, AHL:n järjestys",
    league_noteRw: "voitot varsinaisella peliajalla",
    league_noteRow: "voitot varsinaisella tai jatkoajalla",
    league_noteBlue: "sininen = joukkueessa {{country}}-pelaajia",
    league_noteDiv: "divisioonasijoitus",
    league_noteWc: "villi kortti",
    league_noteGr: "otteluita jäljellä",
    league_noteTank: "järjestys: P, VV, VVJ (pienin ensin)",
};
